export default "__VITE_ASSET__gL6M2FFZ__"